import { useAppStoreDispatch } from "../../contexts/appStore/context";
import { useAppStoreSelector } from "../../contexts/appStore/selectors";
import { toastError } from "../../helpers/toast";
import { MediaSelector, MediaSelectorProps } from "./MediaSelector";
import React from "react";

type MediaSelectorConnectedProps = Omit<MediaSelectorProps,
  | "audioStreamEnabled" | "videoStreamEnabled"
  | "defaultInputAudioDeviceInfo" | "defaultInputVideoDeviceInfo" | "defaultOutputAudioDeviceInfo"
  | "onInputAudioDeviceInfo" | "onInputVideoDeviceInfo" | "onOutputAudioDeviceInfo"
  | "onAudioStreamEnabled" | "onVideoStreamEnabled" | "onMediaCaptureError"
>;

export const MediaSelectorConnected = React.memo((props: MediaSelectorConnectedProps) => {
  const dispatch = useAppStoreDispatch();

  const audioEnabled = useAppStoreSelector(state => state.audioStreamEnabled);
  const videoEnabled = useAppStoreSelector(state => state.videoStreamEnabled);
  const inputAudioDeviceInfo = useAppStoreSelector(state => state.inputAudioDeviceInfo);
  const inputVideoDeviceInfo = useAppStoreSelector(state => state.inputVideoDeviceInfo);
  const outputAudioDeviceInfo = useAppStoreSelector(state => state.outputAudioDeviceInfo);

  return (
    <MediaSelector
      {...props}
      audioStreamEnabled={audioEnabled}
      videoStreamEnabled={videoEnabled}
      defaultInputAudioDeviceInfo={inputAudioDeviceInfo}
      defaultInputVideoDeviceInfo={inputVideoDeviceInfo}
      defaultOutputAudioDeviceInfo={outputAudioDeviceInfo}
      onInputAudioDeviceInfo={(device) => {
        if (device) dispatch("setInputAudioDeviceInfo", device);
      }}
      onInputVideoDeviceInfo={(device) => {
        if (device) dispatch("setInputVideoDeviceInfo", device);
      }}
      onOutputAudioDeviceInfo={(device) => {
        if (device) dispatch("setOutputAudioDeviceInfo", device);
      }}
      onAudioStreamEnabled={(enabled) => dispatch("setAudioStreamEnabled", enabled)}
      onVideoStreamEnabled={(enabled) => dispatch("setVideoStreamEnabled", enabled)}
      onMediaCaptureError={(type) => {
        if (type === "audio") {
          toastError("Veuillez autoriser le navigateur à accéder au microphone");
          dispatch("setAudioStreamEnabled", false);
        }
        if (type === "video") {
          toastError("Veuillez autoriser le navigateur à accéder à la caméra");
          dispatch("setVideoStreamEnabled", false);
        }
      }}
    />
  );
});
